import { Link } from "react-router-dom";

export default function MidPageCTA() {
  return (
    <div className="relative overflow-hidden bg-brand-charcoal border-y border-brand-gold/15 py-10">
      {/* Subtle background texture */}
      <div className="absolute inset-0 bg-gradient-to-r from-brand-gold/5 via-transparent to-brand-gold/5 pointer-events-none" />
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-brand-gold/25 to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-brand-gold/25 to-transparent" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="text-center md:text-left">
          <p className="font-serif text-2xl font-semibold text-brand-white mb-1">
            Ready to inspect your vehicle?
          </p>
          <p className="font-sans text-sm text-brand-gray">
            On-site service starting at $139 — we come to the car, anywhere in NY, NJ, or CT.
          </p>
        </div>
        <div className="flex flex-col sm:flex-row gap-3 shrink-0">
          <Link
            to="/contact"
            className="inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-brand-gold text-brand-black font-sans font-bold text-sm tracking-wide rounded-full hover:bg-brand-gold-light transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-calendar-check-line" />
            Book an On-Site Inspection
          </Link>
          <a
            href="tel:5169833800"
            className="inline-flex items-center justify-center gap-2 px-8 py-3.5 border border-brand-gold/40 text-brand-gold font-sans font-medium text-sm rounded-full hover:bg-brand-gold/8 transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-line" />
            Talk to an Inspector
          </a>
        </div>
      </div>
    </div>
  );
}
